/**
 *
 */
export async function waitForAllPreloadedScriptsToBeLoaded() {
    await new Promise(res => o_global.eventLoader.onAllPreloadScriptsLoaded(10, res));
}
